var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companies"},[_c('CompaniesCatalog',{ref:"CompaniesComponent",attrs:{"item-name":"Company","can-create":_vm.canCreateCustomGroup,"can-update":_vm.canUpdateCustomGroup,"can-delete":_vm.canDeleteCustomGroup},on:{"deleteCompany":_vm.deleteCompany}}),_c('ConfirmModal',{ref:"deleteModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }